<template>
  <div
    class="intro-y flex flex-col lg:flex-row justify-between lg:items-end gap-0 lg:gap-2 mt-8"
  >
    <div class="flex flex-row items-end">
      <div
        class="bg-green-600 px-8 py-2 lg:text-2xl font-bold text-white text-center rounded-md"
      >
        OF
      </div>
      <h2 class="text-lg font-medium ml-4">รายละเอียด {{ of.of_no }}</h2>
    </div>
    <div
      class="flex flex-row justify-end mt-4 lg:mt-0 gap-2"
      v-if="!loadingPage"
    >
      <button
        type="button"
        class="btn btn-warning disabled:opacity-50 flex items-center"
        @click.prevent="duplicationOF()"
        v-show="btnDuplication.show"
        :disabled="btnDuplication.disable"
      >
        <RefreshCcwIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnDuplication.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ทำซ้ำ
      </button>
      <router-link
        type="button"
        :to="{ name: 'preorderOFList' }"
        class="btn box text-gray-700 flex items-center"
      >
        <ArrowLeftIcon class="w-4 h-4 mr-2 hidden md:block" /> Back
      </router-link>
      <button
        type="button"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        @click.prevent="rejectOF()"
        :disabled="btnReject.disabled"
        v-show="!btnReject.hide"
      >
        <ArrowLeftIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnReject.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ดึงเอกสารกลับ
      </button>
      <a
        href="javascript:;"
        class="btn btn-danger disabled:opacity-50 flex items-center"
        data-toggle="modal"
        data-target="#cancel-modal-preview-remark"
        :disabled="btnCancel.disabled"
        v-show="!btnCancel.hide"
      >
        <XCircleIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnCancel.loading"
        />
        <LoadingIcon icon="oval" color="white" v-else class="w-4 h-4 mr-2" />
        ยกเลิกเอกสาร
      </a>
      <a
        v-if="!btnResendHide"
        v-show="!btnResend.hide"
        :disabled="btnResend.disabled"
        href="javascript:;"
        class="btn box disabled:opacity-50 flex items-center border-2"
        data-toggle="modal"
        data-target="#resend-mail-modal-confirm"
      >
        <SendIcon
          class="w-4 h-4 mr-2 hidden md:block"
          v-if="!btnResend.loading"
        />
        <LoadingIcon icon="oval" color="orange" v-else class="w-4 h-4 mr-2" />
        Send Mail
      </a>
      <BtnPrinterMulti
        module="of"
        :query-string="queryString"
        v-if="!btnPrintHide"
      />
    </div>
  </div>
  <div class="grid grid-cols-12 gap-6 mt-0 lg:mt-5">
    <div class="intro-y col-span-12">
      <div class="mt-5">
        <div class="h-10 w-full text-center my-20" v-if="loadingPage">
          <LoadingIcon icon="oval" class="w-12 h-12" />
        </div>
        <div class="horizontal-form" v-else>
          <div class="mb-4" v-if="isApprove">
            <ApproveOF
              :of-id="of.of_id"
              :activity="of.activity_list"
              :employee-id="of.claim_id"
              :show="of.is_approve_token_used == 0"
              :edit="of.flag_edit == 1"
              @reload="reloadOF"
            />
          </div>
          <div class="mb-4">
            <DocumentPath
              :document-path="of.document_path_array"
              :status-code="of.status_code"
              :flag-edit="of.flag_edit"
              :next-status-code="of.next_status"
              :approve-result="of.approve_result_array"
            />
          </div>
          <HeaderCompany
            :img-logo="of.of_comp.comp_logo"
            :status-name="of.status_name"
            :participants="of.participants"
            :document-path="of.document_path_text_array"
          />
          <div class="mt-5">
            <TableSummaryCost :items="of.itemSummary" />
          </div>
          <div class="box intro-y mt-5 p-5">
            <HeaderOwner
              :reqName="of.req_name"
              :companyName="of.of_comp.comp_name_th"
              :buNo="of.bu_no"
              :buName="of.bu_name"
              :telephone="of.telephone"
            />
          </div>
          <div
            class="flex flex-col-reverse lg:flex-none lg:grid lg:grid-cols-3 mt-5 gap-4"
          >
            <div class="box intro-y p-5 col-span-2">
              <div class="font-bold text-lg grid grid-cols-1 lg:grid-cols-4">
                <div class="col-span-3">ข้อมูลการขอซื้อ</div>
                <div
                  v-if="of.ofRefInfo.docNoFull"
                  class="col-span-1 text-gray-600"
                >
                  อ้างอิงจากเลขที่เอกสาร <br />({{ of.ofRefInfo.docNoFull }})
                </div>
              </div>
              <div class="grid grid-cols-1 lg:grid-cols-4 lg:gap-4">
                <div class="col-span-3">
                  <div class="flex flex-row lg:flex-col justify-between mt-4">
                    <label class="form-label font-bold">สกุลเงิน:</label>
                    <div>{{ of.currency }}</div>
                  </div>
                  <div class="flex flex-row lg:flex-col justify-between mt-4">
                    <label class="form-label font-bold">ชนิดการซื้อ:</label>
                    <div>{{ of.orderTypeText }}</div>
                  </div>
                  <!-- รายละเอียด -->
                  <div class="mt-4">
                    <label class="form-label font-bold">รายละเอียด:</label>
                    <div
                      class="overflow-x-auto"
                      v-html="
                        of.req_detail
                          ? of.req_detail.replaceAll('\n', '<br />')
                          : ''
                      "
                    ></div>
                  </div>
                </div>

                <div>
                  <!-- เอกสารจาก Memo -->
                  <div class="mt-4">
                    <label for="" class="form-label font-bold"
                      >เอกสารจาก Memo:</label
                    >
                    <div>
                      <a
                        :href="of.ememo_link"
                        class="text-blue-400"
                        target="_blank"
                        >{{ of.ememo_title }}</a
                      >
                    </div>
                  </div>
                  <!-- ไฟล์แนบ -->
                  <div class="mt-4 col-span-1">
                    <label class="form-label font-bold">ไฟล์แนบ:</label>
                    <AttachFilePreview :data="of.file_attach_array" />
                  </div>
                </div>
              </div>
            </div>

            <div class="box intro-y p-5">
              <div class="font-bold text-lg">ข้อมูลด้านบัญชี</div>
              <GLDate
                class="mt-5"
                url="preorder/of/updateOfGldate"
                :id="of.of_id"
                :glDate="of.glDate"
                :isPermissionVat="of.is_permission_vat"
                :isApprove="isApprove"
                :isClaim="isClaim"
              />
            </div>
          </div>
          <div class="mt-5 gap-4">
            <div class="intro-y box p-5 space-y-4">
              <div class="text-lg font-bold">รายการเบิก</div>
              <TableItemOF
                :items="of.items"
                :is-permission-vat="of.is_permission_vat"
                :is-approve="isApprove"
                :is-claim="isClaim"
                :is-update-material="isUpdateMaterial"
                :comp-code="of.of_comp.comp_no"
                page="detail"
                @updateCancel="updateCancel"
                @updateBudget="updateBudget"
              />
            </div>
          </div>
          <div class="mt-5">
            <TableHistory :items="of.historyArray" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalResendEmail module="preorder" :docId="of.of_id" docType="OF" />
  <ModalCancelRemark
    module="preorder"
    doc-type="of"
    :doc-id="of.of_id"
    redirect-complete="preorderOFList"
  />
</template>

<script lang="ts">
import {
  defineComponent,
  computed,
  reactive,
  onMounted,
  ref,
  onUnmounted
} from 'vue'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { api } from '../../../utils/api'
import alert from '../../../helpers/alert'
import helpers from '../../../helpers'
import ApproveOF from '@/components/approve-of/Main.vue'
import DocumentPath from '@/components/document-path/Main.vue'
import TableSummaryCost from '@/components/TableSummaryCost.vue'
import TableHistory from '@/components/TableHistory.vue'
import AttachFilePreview from '@/components/attach-file/Preview.vue'
import TableItemOF from '@/components/TableItemOF.vue'
import BtnPrinterMulti from '@/components/BtnPrinterMulti.vue'
import ModalResendEmail from '@/components/ModalResendEmail.vue'
import HeaderCompany from '@/components/HeaderCompany.vue'
import HeaderOwner from '@/components/HeaderOwner.vue'
import GLDate from '@/components/GLDate.vue'
import ModalCancelRemark from '@/components/ModalCancelRemark.vue'

export default defineComponent({
  components: {
    ApproveOF,
    DocumentPath,
    TableSummaryCost,
    AttachFilePreview,
    TableHistory,
    BtnPrinterMulti,
    TableItemOF,
    ModalResendEmail,
    HeaderCompany,
    HeaderOwner,
    GLDate,
    ModalCancelRemark
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const loadingPage = computed(() => store.state.global.loadingPage)
    const btnCancel = computed(() => store.state.of.btnCancel)
    const btnReject = computed(() => store.state.of.btnReject)
    const btnResend = computed(() => store.state.global.btnResend)
    const btnResendHide = ref(false)
    const btnPrintHide = ref(false)

    const userInfo = computed(() => store.state.auth.info)
    const { numberFormat, dateFormat } = helpers

    const isOwner = ref(false)
    const isApprove = ref(false)
    const isUpdateMaterial = ref(false)

    const queryString = ref([])
    const vendors = []

    const of = reactive({
      owner_name: '',
      of_no: '',
      status_code: null,
      next_status: null,
      of_id: null,
      claim_id: '',
      glDate: '',
      activity_list: [],
      document_path_text_array: [],
      document_path_array: [],
      approve_result_array: [],
      of_comp: {
        comp_no: '',
        comp_name_th: '',
        comp_logo: ''
      },
      telephone: '',
      bu_no: '',
      bu_name: '',
      currency: '',
      req_name: '',
      req_detail: '',
      ememo_id: '',
      ememo_title: '',
      ememo_link: '',
      flag_edit: 0,
      file_attach_array: [],
      items: [],
      itemSummary: [],
      historyArray: [],
      is_approve_token_used: 0,
      status_name: '',
      participants: '',
      // notePurchase: '',
      orderTypeText: '',
      ofRefInfo: {
        docNoFull: null,
        ofId: null
      },

      is_permission_vat: false
    })

    const btnDuplication = reactive({
      loading: false,
      disable: false,
      show: false
    })

    const rejectOF = async () => {
      store.commit('of/setBtnActive', { type: 'btnReject' })
      await api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/of/editBeforeApprove/${route.params.id}`
        )
        .then(res => {
          if (res.code == 200) {
            store.commit('of/setBtnActive', { type: 'btnReject' })
            router.push({
              name: 'preorderOFFormEdit',
              params: { id: route.params.id }
            })
          } else {
            alert.error(res.message)
          }
        })
    }

    const reloadOF = () => {
      loadOF()
    }

    const isClaim = computed(() => store.state.of.isClaim)

    const loadOF = async () => {
      if (route.params.id) {
        await api
          .get(
            `${process.env.VUE_APP_API_URL}/preorder/of/getByOfId/${route.params.id}`
          )
          .then(async res => {
            of.of_id = res.data.of_id
            of.activity_list = res.data.allow_list_array
              ? res.data.allow_list_array.activity_list
              : []
            of.owner_name = res.data.owner_name
            of.of_no = res.data.doc_no_full
            of.claim_id = res.data.claim_id
            of.is_approve_token_used = res.data.is_approve_token_used
            of.status_code = res.data.status_code
            of.next_status = res.data.next_status
            of.document_path_text_array = res.data.document_path_text_array
            of.document_path_array = res.data.document_path_array
            of.approve_result_array = res.data.approve_result_array
            of.req_name = res.data.req_name
            of.telephone = res.data.telephone
            of.bu_no = res.data.bu_no
            of.bu_name = res.data.bu_name
            of.currency = res.data.currency_code
            of.req_detail = res.data.req_detail
            of.items = res.data.items
            of.flag_edit = res.data.flag_edit
            of.status_name = res.data.status_name
            of.participants = res.data.participants
            of.itemSummary = res.data.itemSummary
            of.historyArray = res.data.history_array
            of.orderTypeText = res.data.order_type_text
            of.glDate = res.data.gl_date
            // of.notePurchase =
            //   res.data.note_purchase !== null
            //     ? res.data.note_purchase
            //     : 'ไม่พบข้อมูล'

            // of.vendorCode = res.data.vendor_code
            // of.vendorName = res.data.vendor_name
            // of.vendorAddress = res.data.vendor_address
            // of.vendorEamil = res.data.vendor_email
            // of.vendorTelephone = res.data.vendor_telephone
            // of.poDocTypeText = res.data.po_doc_type_text
            // of.reasonChosenVendor = res.data.reason_chosen_vendor
            of.is_permission_vat = res.data.is_permission_vat != 0

            // formOF.notePurchaseDisplay = res.data.is_permission_purchase == 1
            // formOF.notePurchase =
            //   res.data.note_purchase !== null ? res.data.note_purchase : ''

            of.ememo_id = res.data.ememo_id
            of.ememo_title = res.data.ememo_title
            of.ememo_link = `${process.env.VUE_APP_BASE_URL}/memo/myActivities/form/${res.data.ememo_id}/detail`
            of.file_attach_array = res.data.file_attach_array

            of.of_comp = store.getters['global/companyFind'](res.data.of_comp)
            // console.log('of.of_comp: ', of.of_comp)

            const isPurchaseHead = await store.getters[
              'auth/checkPurchaseHead'
            ](res.data.of_comp)
            const isPurchaseAdmin = await store.getters[
              'auth/checkPurchaseAdmin'
            ](res.data.of_comp)

            if (res.data.status_code == 'OF_COMPLETE') {
              btnDuplication.show = true
            }

            if (res.data.of_ref_info) {
              of.ofRefInfo.docNoFull = res.data.of_ref_info.doc_no_full
              of.ofRefInfo.ofId = res.data.of_ref_info.of_id
            }

            if (
              res.data.status_code == 'OF_COMPLETE' &&
              (isPurchaseHead || isPurchaseAdmin)
            ) {
              store.commit('of/setBtn', { type: 'btnCancel', value: 'hide' })
            }
            // console.log(isPurchaseAdmin, isPurchaseHead)
            if (
              ['PA_REVIEW', 'HPD_REVIEW'].includes(res.data.status_code) &&
              (isPurchaseHead || isPurchaseAdmin)
            ) {
              // console.log('show update material vendor')
              isUpdateMaterial.value = true
            } else {
              isUpdateMaterial.value = false
            }

            if (
              store.getters['auth/checkDocOwner'](res.data.owner_id) &&
              res.data.status_code != 'OF_DRAFT' &&
              res.data.status_code != 'OF_COMPLETE'
            ) {
              store.commit('global/setBtnHide', {
                type: 'btnResend',
                status: false
              })
            }

            if (res.data.status_code == 'OF_CANCELLED') {
              btnResendHide.value = true
              btnPrintHide.value = true
            }

            if (userInfo.value.employeeId == res.data.owner_id) {
              isOwner.value = true
              if (
                res.data.is_editing != 1 &&
                res.data.status_code == 'PA_REVIEW'
              ) {
                store.commit('of/setBtn', { type: 'btnReject', value: 'hide' })
              } else {
                if (
                  store.state.of.btnReject.hide &&
                  res.data.status_code == 'PA_REVIEW'
                ) {
                  store.commit('of/setBtn', {
                    type: 'btnReject',
                    value: 'hide'
                  })
                }
              }
            }
            isApprove.value = false
            if (res.data.allow_list_array) {
              res.data.allow_list_array.activity_list.map(item => {
                if (item.employee_id == userInfo.value.employeeId) {
                  isApprove.value = true
                }
              })
            }

            store.commit(
              'of/setIsClaim',
              res.data.claim_id === null && isApprove.value
            )

            store.commit('of/setIsApprove', false)

            store.commit('global/setOverBudget', {
              message:
                res.data.is_over_budget == 1
                  ? 'เกินงบประมาณ'
                  : 'อยู่ในงบประมาณ',
              isOver: res.data.is_over_budget == 1,
              show: true
            })
            if (res.data.items.length > 0) {
              getVendorItem(res.data.of_id, res.data.items)
            }
          })
          .catch(e => {
            alert.error(e.message)
          })
      }
    }

    const updateCancel = data => {
      api
        .put(
          `${process.env.VUE_APP_API_URL}/preorder/of/cancelItemOnComplete/${data.itemId}`,
          {
            reason: data.reason
          }
        )
        .then(res => {
          if (res.code == 200) {
            alert.success()
            for (const i in of.items) {
              if (of.items[i].of_item_id == data.itemId) {
                of.items[i].history = data.reason
                of.items[i].cancel_flag = 'c'
              }
            }
          } else {
            alert.error(res.message)
          }
        })
        .catch(e => {
          alert.error(e.message)
        })
    }

    const updateBudget = data => {
      for (const i in of.items) {
        if (of.items[i].of_item_id == data.itemId) {
          of.items[i].budget_bu_name = data.budgetInfo.budget_bu_name
          of.items[i].budget_bu_code = data.budgetInfo.budget_bu_code
          of.items[i].budget_code = data.budgetInfo.budget_code
          of.items[i].budget_subsidiary = data.budgetInfo.budget_subsidiary
          of.items[i].budget_name = data.budgetInfo.budget_name
          of.items[i].budget_subledger = data.budgetInfo.budget_subledger
          of.items[i].budget_subledger_name =
            data.budgetInfo.budget_subledger_name
        }
      }
    }

    const getVendorItem = (docId, items) => {
      // find vendor code
      items.map(item => {
        if (!vendors.find(code => code == item.vendor_code)) {
          const q = `?docId=${docId}&vendorCode=${item.vendor_code}`
          vendors.push(item.vendor_code)
          queryString.value.push(q)
        }
      })
      // console.log('queryString: ', queryString.value)
    }

    const duplicationOF = async () => {
      btnDuplication.disable = true
      btnDuplication.loading = true

      await api
        .post(`${process.env.VUE_APP_API_URL}/preorder/of/clone`, {
          of_id: route.params.id
        })
        .then(res => {
          // console.log('of clone: ', res)
          if (res.code == 200) {
            console.log('redirect ')
            router.push({
              name: 'preorderOFFormEdit',
              params: { id: res.data.ofHeader.of_id }
            })
          } else if (res.code == 422) {
            alert.validatorShow(res.validator)
            btnDuplication.disable = false
            btnDuplication.loading = false
          } else {
            alert.error(res.message)
          }
        })
        .catch(() => {
          btnDuplication.disable = false
          btnDuplication.loading = false
        })
    }

    onUnmounted(() => {
      console.log('unmounted page of detail')
      store.commit('of/initBtn')
      isOwner.value = false
      isApprove.value = false
    })

    onMounted(async () => {
      console.log('mounted page of detail')
      await store.dispatch('global/loadCompany')
      await store.dispatch('global/loadCash')
      await loadOF()
      store.commit('global/setLoadingPage', false)
    })

    return {
      btnCancel,
      btnReject,
      rejectOF,
      of,
      // formOF,
      reloadOF,
      loadingPage,
      numberFormat,
      dateFormat,
      isOwner,
      isApprove,
      isClaim,
      // saveNotePurchase,
      btnResend,
      updateCancel,
      updateBudget,
      btnResendHide,
      btnPrintHide,
      queryString,
      isUpdateMaterial,
      duplicationOF,
      btnDuplication
    }
  }
})
</script>

<style scoped></style>
